import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import useAreaAbout from 'hooks/Meteorology/Weather/Area/About/useAreaAbout';
import usePolaritySelection from 'hooks/Meteorology/Weather/Area/About/usePolaritySelection';
import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import FormModal from 'components/FormModal';
import CentralizedSpinner from 'components/CentralizedSpinner';
import AboutMobile from 'components/Meteorology/Weather/Area/About/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';
import DescriptionPanel from './DescriptionPanel';
import DescriptionForm from './DescriptionForm';
import ImagePanel from './ImagePanel';

export default function About({
  areaAcronym,
  areaLabel,
}: {
  areaAcronym: string,
  areaLabel: string,
}) {
  const {
    showPolaritySelector,
    polarity,
    handlePolarityChange,
  } = usePolaritySelection(areaAcronym);
  const [editing, setEditing] = useState(false);
  const [description, setDescription] = useState('');
  const { about, isFetching } = useAreaAbout({ polarity, area: areaAcronym });
  const userIsAdmin = useSelector(selectUserIsAdmin);
  const isMobile = useIsMobile();

  useEffect(() => {
    setDescription(about?.data || '');
  }, [about]);

  if (isFetching) {
    return <CentralizedSpinner />;
  }

  if (isMobile) {
    return (
      <>
        <AboutMobile
          name={areaLabel}
          description={description}
          imageSrc={`data:image/png;base64,${about?.imageBase64}`}
          hasImage={Boolean(about?.imageBase64)}
          showPolaritySelector={showPolaritySelector}
          polarity={polarity}
          handlePolarityChange={handlePolarityChange}
          isAdmin={userIsAdmin}
          onEdit={() => setEditing(true)}
        />
        <FormModal title="Editar descrição" show={editing} onHide={() => setEditing(false)}>
          <DescriptionForm
            areaId={about?.id}
            aboutDescription={description}
            setAboutDescription={setDescription}
          />
        </FormModal>
      </>
    );
  }

  return (
    <>
      <Row className="flex-fill p-5 h-100">
        <Col md={4}>
          <DescriptionPanel description={description} setEditing={setEditing} />
        </Col>
        <Col md={8} className="mt-3 mt-md-0">
          <ImagePanel
            name={areaLabel}
            imageSrc={`data:image/png;base64,${about?.imageBase64}`}
            showPolaritySelector={showPolaritySelector}
            polarity={polarity}
            handlePolarityChange={handlePolarityChange}
          />
        </Col>
      </Row>
      <FormModal title="Editar descrição" show={editing} onHide={() => setEditing(false)}>
        <DescriptionForm
          areaId={about?.id}
          aboutDescription={description}
          setAboutDescription={setDescription}
        />
      </FormModal>
    </>
  );
}
